import React, { useState } from 'react'
import { Input } from 'reactstrap'
// import axios from "axios";

const money = (n) =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 2,
  }).format(Number(n) || 0);

const TablaNominasCreate=(props)=> {
  const quincena = props.importe
  const index = props.index;
  const [sueldo, setSueldo] = useState(quincena);
  const [nombre, setNombre] = useState(props.nombre);
  const [puesto, setPuesto] = useState(props.puesto);
  const [fecha, setFecha] = useState(props.fecha);
  const [key, setKey] = useState(props.id);
  const sueldoModificado = props.sueldoModificado
  const notas = props.comentarios

  // Días no justificados del periodo y sueldo ya con el descuento aplicado.
  // Vienen calculados desde NominasCreate, que es quien conoce el periodo.
  const faltas = Number(props.faltas || 0);
  const neto = props.neto != null ? Number(props.neto) : Number(sueldo || 0);

  return (
    <>
      <td>{nombre}</td>
      {/* <td>{props.plantel}</td>*/}
      <td>{props.area}</td>
      <td>{puesto}</td>
      <td>{money(sueldo)}</td>
      <td align="right">
        {faltas > 0 ? (
          <span style={{ color: "#dc3545", fontWeight: 600 }}>{faltas}</span>
        ) : (
          "-"
        )}
      </td>
      <td style={{ minWidth: 110 }}>
        <Input
          type="number"
          step="any"
          placeholder="0.00"
          value={props.ajuste ?? ""}
          onChange={(e) => props.onAjuste && props.onAjuste(e.target.value)}
          style={{
            textAlign: "right",
            color: Number(props.ajuste) < 0 ? "#c00" : Number(props.ajuste) > 0 ? "#080" : undefined,
          }}
        />
      </td>
      <td style={{ minWidth: 170 }}>
        <Input
          type="text"
          placeholder={Number(props.ajuste) ? "Obligatorio" : "Bono, préstamo…"}
          value={props.conceptoAjuste || ""}
          onChange={(e) => props.onConceptoAjuste && props.onConceptoAjuste(e.target.value)}
          invalid={Number(props.ajuste) !== 0 && !!props.ajuste && !String(props.conceptoAjuste || "").trim()}
        />
      </td>
      <td align="right" style={{ fontWeight: 600, color: neto < 0 ? "#c00" : undefined }}>{money(neto)}</td>
      <td>{props.banco || "-"}</td>
      <td>{props.clabe || "-"}</td>
      <td>{props.titularCuenta || "-"}</td>
      <td><Input
        type="number"
min="0"
step="any"
        key={key}
        required
        onBlur ={(e)=>{sueldoModificado(e.target.value, index, sueldo)
        }}
        /></td>
        <td><Input
        type="text"
        key={key}
        onBlur ={(e)=>{notas(e.target.value, index)
        }}
        /></td>
    </>
  );
}


export default TablaNominasCreate
